import * as yup from 'yup';
import { AlunoModelValidator } from '../Aluno';
import { IValidator } from '../IValidator';
import { PreProjetoModel } from './Model';

const preProjetoSchema = yup.object().shape<PreProjetoModel>({
  id: yup.number(),
  parametroPreProjetoId: yup.number(),
  tema: yup.string().required('Tema é obrigatório'),
  titulo: yup.string().required('Título é obrigatório'),
  justificativa: yup.string().required('Justificativa é obrigatória'),
  desenvolvimento: yup.string().required('Desenvolvimento é obrigatório'),
  bibliografia: yup.string().required('Bibliografia é obrigatória'),
  aluno: AlunoModelValidator.schema
})

export const PreProjetoModelValidator = new IValidator<{
  tema: string,
  titulo: string,
  justificativa: string,
  desenvolvimento: string,
  bibliografia: string,
}>(preProjetoSchema);

const justificativaReprovacaoSchema = yup.object().shape({
  justificativaReprovacao: yup
    .string()
    .required('Por favor informe a justificativa')
});

export const JustificativaReprovacaoValidator = new IValidator<{ justificativaReprovacao: string }>(
  justificativaReprovacaoSchema
);

const parametrosSchema = yup.object().shape({
  serie: yup.string().required('Campo Obrigatorio.').test(
    'serie',
    'A serie não pode ser 0 (zero).',
    value => value && value > 0),
  dataDeInicio: yup.string().required('Campo Obrigatorio.'),
  horaDeInicio: yup.string().required('Campo Obrigatorio.'),
  dataDeFim: yup.string().required('Campo Obrigatorio.'),
  horaDeFim: yup.string().required('Campo Obrigatorio.'),
  dataDeInicioInscricoes: yup.string().required('Campo Obrigatorio.'),
  horaDeInicioInscricoes: yup.string().required('Campo Obrigatorio.'),
  dataDeFimInscricoes: yup.string().required('Campo Obrigatorio.'),
  horaDeFimInscricoes: yup.string().required('Campo Obrigatorio.'),
  dataDeInicioPF: yup.string().required('Campo Obrigatorio.'),
  horaDeInicioPF: yup.string().required('Campo Obrigatorio.'),
  dataDeFimPF: yup.string().required('Campo Obrigatorio.'),
  horaDeFimPF: yup.string().required('Campo Obrigatorio.'),
  dataDeInicioSF: yup.string().required('Campo Obrigatorio.'),
  horaDeInicioSF: yup.string().required('Campo Obrigatorio.'),
  dataDeFimSF: yup.string().required('Campo Obrigatorio.'),
  horaDeFimSF: yup.string().required('Campo Obrigatorio.'),
  dataDeInicioTF: yup.string().required('Campo Obrigatorio.'),
  horaDeInicioTF: yup.string().required('Campo Obrigatorio.'),
  dataDeFimTF: yup.string().required('Campo Obrigatorio.'),
  horaDeFimTF: yup.string().required('Campo Obrigatorio.')
})

export const ParametrosPreProjetoValidator = new IValidator<{
  serie: string,
  dataDeInicio: string, horaDeInicio: string,
  dataDeFim: string, horaDeFim: string,
  dataDeInicioInscricoes: string, horaDeInicioInscricoes: string,
  dataDeFimInscricoes: string, horaDeFimInscricoes: string,
  dataDeInicioPF: string, horaDeInicioPF: string,
  dataDeFimPF: string, horaDeFimPF: string,
  dataDeInicioSF: string, horaDeInicioSF: string,
  dataDeFimSF: string, horaDeFimSF: string,
  dataDeInicioTF: string, horaDeInicioTF: string,
  dataDeFimTF: string, horaDeFimTF: string
}>(parametrosSchema);